import { render, staticRenderFns } from "./PDFWiki.vue?vue&type=template&id=25ee7ff9&scoped=true&"
import script from "./PDFWiki.vue?vue&type=script&lang=js&"
export * from "./PDFWiki.vue?vue&type=script&lang=js&"
import style0 from "./PDFWiki.vue?vue&type=style&index=0&id=25ee7ff9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ee7ff9",
  null
  
)

export default component.exports